var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.01688 9.51015C7.01688 9.51015 9.49076 14.4159 14.4386 16.9856C14.4386 16.9856 14.9862 17.1476 15.6046 16.5247L16.5708 15.5904C16.5708 15.5904 17.2279 14.5783 18.8125 15.3958L23.2957 18.0429C23.2957 18.0429 24.8803 18.7047 23.2957 20.2619L20.3584 23.2593C20.3584 23.2593 19.7014 24.505 16.4163 23.7654C16.4163 23.7654 5.23877 20.8011 0.368289 7.87489C0.368289 7.87489 -0.714034 5.53883 0.832149 3.66998L4.07912 0.37353C4.07912 0.37353 5.40136 -0.720676 6.05839 0.836466L8.45461 5.43003C8.45461 5.43003 9.34355 6.4811 8.22271 7.64896L7.21784 8.58324C7.21784 8.58324 6.68503 8.92056 7.01688 9.51015Z",
    fill: "#ff5a3c"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_612"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.d2d6a2f5ea47c49ca21b8772d75d54ae.svg";
export { ForwardRef as ReactComponent };